<template>
    <div class="rfBG">

        <div class="refundSite-fadeOut">
            <div class="refundSite-fadeOut-title" v-html="$t('sdp.refund.close.message.001')"></div>

            <div v-if="cntryCode == 'US' && usExpiryYn == 'Y'" class="refundSite-fadeOut-content">
                <div class="refundSite-fadeOut-content-wrap">
                    <table border="1" class="table_list" summary="">
                        <caption></caption>
                        <colgroup>
                            <col width="50%">
                            <col width="50%">
                        </colgroup>

                        <thead>
                        <tr>
                            <th scope="col" v-html="$t('sdp.refund.close.message.002')"></th>
                            <th scope="col" v-html="$t('sdp.refund.close.message.004')"></th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr>
                            <td v-html="$t('sdp.refund.close.us.message.001')"></td>
                            <td v-html="$t('sdp.refund.close.message.005')"></td>
                        </tr>
                        </tbody>
                    </table>
                    <div class="message">
                        <p v-html="$t('sdp.refund.close.message.010')"></p>
                        <p v-html="$t('sdp.refund.close.message.011')"></p>
                        <p v-html="$t('sdp.refund.close.message.012')"></p>
                        <div class="notice-message">
                            <div class="notice-title" v-html="$t('sdp.refund.close.message.013')"></div>
                            <ul>
                                <li>{{ $t("sdp.refund.close.message.014") }}
                                    <div>{{ $t("sdp.refund.close.message.015") }}</div>
                                </li>
                                <li v-html="$t('sdp.refund.close.message.016')"></li>
                                <li v-html="$t('sdp.refund.close.message.017')"></li>
                                <li v-html="$t('sdp.refund.close.message.018')"></li>
                            </ul>
                        </div>
                        <p v-html="$t('sdp.refund.close.message.008')"></p>
                        <p v-html="$t('sdp.refund.close.message.009')"></p>
                    </div>
                </div>
            </div>
            <div v-else class="refundSite-fadeOut-content">
                <div class="refundSite-fadeOut-content-wrap">
                    <table border="1" class="table_list" summary="">
                        <caption></caption>
                        <colgroup>
                            <col width="50%">
                            <col width="50%">
                        </colgroup>

                        <thead>
                        <tr>
                            <th scope="col" v-html="$t('sdp.refund.close.message.002')"></th>
                            <th scope="col" v-html="$t('sdp.refund.close.message.004')"></th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr>
                            <td v-if="cntryCode == 'US'" v-html="$t('sdp.refund.close.us.message.001')"></td>
                            <td v-else v-html="$t('sdp.refund.close.message.003')"></td>
                            <td v-html="$t('sdp.refund.close.message.005')"></td>
                        </tr>
                        </tbody>
                    </table>
                    <div class="message">
                        <p v-if="cntryCode == 'US'" v-html="$t('sdp.refund.close.us.message.002')"></p>
                        <p v-else v-html="$t('sdp.refund.close.message.006')"></p>
                        <p v-html="$t('sdp.refund.close.message.007')"></p>
                        <p v-html="$t('sdp.refund.close.message.008')"></p>
                        <p v-html="$t('sdp.refund.close.message.009')"></p>
                    </div>
                </div>
            </div>
            <div class="copyright" v-html="$t('sdp.refund.close.message.019')"></div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "ClosingRefund",
        data() {
            return {
                usExpiryYn: "N",
                cntryCode: _domainCntryCode
            }
        },
        mounted() {
            $("#header").hide();
            $("#footer").hide();

            var usExpiryDate = new Date("2022/07/04");
            var nowDate = new Date();
            if(nowDate < usExpiryDate) {
                this.usExpiryYn = "Y";
            }

            this.$nextTick(function() {
                if(this.cntryCode == "WASU") {
                    this.$i18n.locale = "engu";
                }
            });
        },
        watch: {
            $route: "fetchData"
        },
        computed: {
        },
        methods: {
            track () {
                console.log('@@@@ track:', this.$router.currentRoute.path);
                this.$ga.page(this.$router.currentRoute.path)
            },
        }
    }
</script>

<style scoped>

</style>